import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { WidgetComponent } from 'app/widget/widgets/widget-component';
import { GroupDashboardService } from 'app/groups/services/group-dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { Cache } from 'core/models/cache';
import { TableDatasource, DataTypes } from '@gamelearn/skeletor/models';
import { StoreService, ListHelperService } from 'core/services';
import { Subscription } from 'rxjs';
import { UtilsWidgetService } from '../services/utils-widget.service';

@Component({
  selector: 'lms-last-finished-students-widget',
  templateUrl: './last-finished-students-widget.component.html',
  styleUrls: ['./last-finished-students-widget.component.scss']
})
export class LastFinishedStudentsWidgetComponent implements WidgetComponent, OnInit, OnDestroy {
  @Input() data: any;
  @Input() key?: string;

  public listId = 'LAST_FINISHED_STUDENTS_LIST';
  public studentsCache = new Cache();
  public students: any[];
  public hourFormat = DateTime.TIME_24_SIMPLE;
  public dataSource: TableDatasource;
  private tooltipSubscription: Subscription = new Subscription();
  public tooltipText: string;

  constructor(
    public groupDashboardService: GroupDashboardService,
    public translate: TranslateService,
    public listHelper: ListHelperService
  ) {}

  ngOnInit() {
    this.groupDashboardService
      .getLastFinishedStudents({
        groupId: this.data.group._id
      })
      .subscribe((students) => {
        this.studentsCache.data = students;
        StoreService.merge(this.listId, { active: true });
        this.dataSource = new TableDatasource({
          docs: students,
          columns: [
            {
              source: 'email',
              label: this.translate.instant('nouns.email'),
              allowFiltering: false,
              sortable: false
            },
            {
              source: 'endDate',
              label: this.translate.instant('groups.dashboard.endDate'),
              allowFiltering: false,
              sortable: false,
              dataType: DataTypes.datetime,
              valueParser: (value) => {
                const format = DateTime.DATETIME_MED_WITH_SECONDS;
                return this.listHelper.parseDate(value, 'utc', format);
              }
            }
          ]
        });
      });

    this.tooltipSubscription = StoreService.get(this.data.action).subscribe((tooltipObject) => {
      this.tooltipText = UtilsWidgetService.containTooltip(tooltipObject, this.data.action, this.key);
    });
  }

  ngOnDestroy(): void {
    this.tooltipSubscription.unsubscribe();
  }
}
